// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23TsH","inner":"Footer_inner__2A4EE","nextIcon":"Footer_nextIcon___6L0H","innerLeft":"Footer_innerLeft__2Bapk"};